<template>
  <ion-radio
    slot="start"
    :value="self"
    :checked="value === self"
    @ionSelect="$emit('input', $event.detail.value)"
  ></ion-radio>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    self: {
      required: true
    }
  }
};
</script>

<style>
</style>